/**
 * DASHBOARD-REPARTITION-SKELETON.WIDGET
 * Skeleton adapté à la forme du graphique de répartition
 * (dashboard-repartition-bars.widget.tsx) : mêmes proportions (barres 22px,
 * conteneur 110px, résumé Gollac optionnel) pour éviter tout saut de layout
 * au switch skeleton -> vraies données.
 */
import Skeleton from "@/components/skeleton"

interface Props {
  showSummary?: boolean //Ligne "Salariés exposés/sécurisés" (mode Gollac)
  barCount?: number
}

//Hauteurs (% de 110px) variées pour un rendu moins mécanique qu'un plateau uniforme
const BAR_HEIGHTS = [8, 18, 14, 6, 32, 55, 68, 88, 72, 58]

export default function DashboardRepartitionSkeletonWidget(props: Props) {
  const barCount = props.barCount ?? BAR_HEIGHTS.length

  return (
    <div style={{ width: 410, margin: 10 }}>
      {props.showSummary && (
        <div className="flex mb-20" style={{ gap: 24 }}>
          <div className="w-40" />
          <div className="flex1" style={{ textAlign: "center" }}>
            <Skeleton width={110} height={12} style={{ margin: "0 auto 8px" }} />
            <Skeleton width={30} height={20} isInline />
          </div>
          <div className="flex1" style={{ textAlign: "center" }}>
            <Skeleton width={110} height={12} style={{ margin: "0 auto 8px" }} />
            <Skeleton width={30} height={20} isInline />
          </div>
        </div>
      )}

      <div className="flex">
        {Array.from({ length: barCount }, (_, i) => (
          <div className="flex1" key={i}>
            <div className="flex flex-dcol" style={{ height: 110, justifyContent: "flex-end" }}>
              <Skeleton
                width={22}
                height={Math.max(4, (BAR_HEIGHTS[i % BAR_HEIGHTS.length] / 100) * 110)}
                borderRadius="8px 8px 0 0"
                style={{ margin: "0 auto" }}
              />
            </div>
            <Skeleton width="100%" height={4} style={{ marginTop: 4 }} />
          </div>
        ))}
      </div>

      <div className="flex" style={{ marginTop: 20, gap: 14 }}>
        <Skeleton width={140} height={28} />
        <Skeleton width={140} height={28} />
      </div>
    </div>
  )
}
